var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import getMouseX from '../../utils/getMouseX';
import getGrid from '../../utils/getGrid';
import Header from './Header';
import Body from './Body';
import NowMarker from './Marker/NowMarker';
import PointerMarker from './Marker/PointerMarker';
var Timeline = /** @class */ (function (_super) {
    __extends(Timeline, _super);
    function Timeline(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMouseMove = function (e) {
            var time = _this.props.time;
            _this.setState({ pointerDate: time.fromX(getMouseX(e)) });
        };
        _this.handleMouseLeave = function () {
            _this.setState({ pointerHighlighted: false });
        };
        _this.handleMouseEnter = function () {
            _this.setState({ pointerVisible: true, pointerHighlighted: true });
        };
        _this.state = {
            pointerDate: null,
            pointerHighlighted: false,
            pointerVisible: false,
        };
        return _this;
    }
    Timeline.prototype.render = function () {
        var _a = this.props, now = _a.now, time = _a.time, timebar = _a.timebar, tracks = _a.tracks, sticky = _a.sticky, clickElement = _a.clickElement;
        var _b = this.state, pointerDate = _b.pointerDate, pointerVisible = _b.pointerVisible, pointerHighlighted = _b.pointerHighlighted;
        var grid = getGrid(timebar);
        return (_jsxs("div", __assign({ className: "rt-timeline", style: { width: time.timelineWidthStyle } }, { children: [now && _jsx(NowMarker, { now: now, visible: true, time: time }), pointerDate && (_jsx(PointerMarker, { date: pointerDate, time: time, visible: pointerVisible, highlighted: pointerHighlighted })), _jsx(Header, { time: time, timebar: timebar, onMove: this.handleMouseMove, onEnter: this.handleMouseEnter, onLeave: this.handleMouseLeave, width: time.timelineWidthStyle, sticky: sticky }), _jsx(Body, { time: time, grid: grid, tracks: tracks, clickElement: clickElement })] })));
    };
    return Timeline;
}(Component));
export default Timeline;
